import { Card, Popover, PopoverBody, Spinner, Table } from "reactstrap";
import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
import NoDataFoundIcon from "Assets/Icons/NoDataFoundIcon";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import styled from "styled-components";
import {
  ColorCodeInterface,
  RiskColorCode,
} from "utilFunctions/Constants/Constants";
import DownArrow from "Assets/Icons/downArrow30.png";
import UpArrow from "Assets/Icons/upArrow30.png";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { capitalizeWords } from "utilFunctions/helperFunctions/utilFunctions";
import { useState } from "react";
import "./index.css";
import FeedbackViewModal from "Pages/Faculties/FeedbackViewModal";
import Typography from "Components/CommonComponents/Typography";
import { returnFollowUpCount } from "utilFunctions/shared/CommonTable/RenderColumns";
const SORT_ASC = "ASC";
const SORT_DESC = "DESC";
const RiskStyledDiv = styled<any>("div")`
  background-color: ${(props: any) => props.color};
  border-radius: 4px;
  padding: 4px;
  width: fit-content;
  cursor: pointer;
`;
const RiskStyledDSpan = styled<any>("span")`
  color: ${(props: any) => props.color};
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
`;
export const returnMarkedvaluue = (
  message: string,
  markedLectureCount: any,
  unmarkedLectureCount: any
) => {
  const markedsvalue: any = [];

  markedsvalue.push({
    label: "Marked " + message + ":",
    value: markedLectureCount,
  });
  markedsvalue.push({
    label: "Total " + message + ":",
    value: markedLectureCount + unmarkedLectureCount,
  });
  return markedsvalue;
};
export const returnTargetValuue = (
  message1: string,
  message2: string,
  markedLectureCount: any,
  totalLectureCount: any
) => {
  const markedsvalue: any = [];

  markedsvalue.push({
    label: message1 + ":",
    value:
      markedLectureCount && markedLectureCount != null
        ? markedLectureCount
        : "NA",
  });
  markedsvalue.push({
    label: message2 + ":",
    value:
      totalLectureCount && totalLectureCount != null ? totalLectureCount : "NA",
  });
  return markedsvalue;
};
export const returnCumulativeTargetValuue = (
  message1: string,
  message2: string,
  plLecStatus: any
) => {
  const markedsvalue: any = [];
  plLecStatus.forEach((item: any) => {
    markedsvalue.push({
      label: "Subject" + ":",
      value: item?.subj,
    });
    markedsvalue.push({
      label: message1 + ":",
      value: item?.markedPlLecCount != null ? item?.markedPlLecCount : "NA",
    });
    markedsvalue.push({
      label: message2 + ":",
      value: item?.monthlyTarget != null ? item?.monthlyTarget : "NA",
    });
  });
  return markedsvalue;
};
export const returnPercentage = (
  markedLectureCount: any,
  unmarkedLectureCount: any
) => {
  const markedLectures = markedLectureCount;
  const unmarkedLectures = unmarkedLectureCount;
  let percentage = 0;
  if (markedLectures != 0 || unmarkedLectures != 0) {
    percentage =
      (Number(markedLectures) /
        (Number(markedLectures) + Number(unmarkedLectures))) *
      100;
    percentage = parseFloat(percentage.toFixed(0));
  }
  return percentage >= 100 ? 100 : percentage;
};
export function calculateCumulativePercentage(plLecStatus: any) {
  let totalMarked = 0;
  let totalLectures = 0;
  let percentage = 0;
  if (plLecStatus && plLecStatus != null && Array.isArray(plLecStatus)) {
    plLecStatus.forEach((item: any) => {
      const markedCount =
        item.markedPlLecCount != null ? item.markedPlLecCount : 0;
      const totalCount = item.monthlyTarget != null ? item.monthlyTarget : 0;

      if (totalCount > 0) {
        totalMarked += markedCount;
        totalLectures += totalCount;
      }
    });
  } else if (
    plLecStatus &&
    plLecStatus != null &&
    plLecStatus?.monthlyTarget != null
  ) {
    totalMarked = plLecStatus?.markedPlLecCount;
    totalLectures = plLecStatus?.monthlyTarget;
  } else {
    return 0;
  }

  if (totalLectures === 0) {
    return 0;
  }
  percentage = (Number(totalMarked) / Number(totalLectures)) * 100;
  percentage = parseFloat(percentage.toFixed(0));
  return percentage >= 100 ? 100 : percentage;
}
export const returnRiskSegment = (
  percentage: number,
  additionalContent: any,
  isPlannedLecture: boolean
) => {
  const segment: any =
    percentage > 75
      ? "High"
      : percentage < 75 && percentage < 50
      ? "Moderate"
      : "Low";
  const colorCode = RiskColorCode.find(
    (item: ColorCodeInterface) => item.name === segment
  );
  return (
    <RiskStyledDiv color={isPlannedLecture ? "#F5F5F5" : colorCode?.bgColor}>
      <RiskStyledDSpan color={isPlannedLecture ? "#757575" : colorCode?.color}>
        {additionalContent}
      </RiskStyledDSpan>
    </RiskStyledDiv>
  );
};
const FacultiesTable = ({
  tableloading,
  tableHeading,
  tableData,
  sortColumn,
  setSortColumn,
  sortOrder,
  setSortOrder,
  selectedBatch,
  regionId,
  sortingArray,
}: any) => {
  const { screen }: any = useWindowSize();
  const navigate = useNavigate();
  const [popoverOpen, setPopoverOpen] = useState<boolean>(false);
  const [popoverContent, setPopoverContent] = useState<any>([]);
  const [hoveredColumn, setHoveredColumn] = useState<string | null>(null);
  const [isLectureViewModal, setIsLectureViewModal] = useState<any>(false);
  const [selectedRowItem, setSelectedRowItem] = useState({});

  const togglePopover = (column: string, content: string) => {
    setHoveredColumn(column);
    setPopoverContent(content);
    setPopoverOpen(!popoverOpen);
  };

  const closePopover = () => {
    setHoveredColumn(null);
    setPopoverOpen(false);
  };
  const routeToPerformance = (item: any) => {
    navigate("/admin/faculties/" + item?.id, {
      replace: false,
      state: {
        faculty: item,
        selectedBatch: selectedBatch,
        selectedRegion: regionId,
      },
    });
  };
  const renderingTime = (date: any) => {
    return <div className="d-flex">{moment(date).format("D MMM YY")}</div>;
  };
  const handleOverAllratingmodal = (item: any) => {
    setSelectedRowItem((prevRowItem) => ({ ...prevRowItem, ...item }));
    setIsLectureViewModal(true);
  };
  const mapData = (aggregatedData: any, updatedDataForModal: any): [] => {
    const updatedFeedbackData = {
      behaviourInClassResponseAvg: aggregatedData.behaviourInClassResponseAvg,
      teachingPaceResponseAvg: aggregatedData.teachingPaceResponseAvg,
      weightedNumberOfFeedback: aggregatedData.weightedNumberOfFeedback,
      overallRatingResponseAvg: aggregatedData.overallRatingAvg,
      doubtResolutionResponseAvg: aggregatedData.doubtResolutionResponseAvg,
    };
    updatedDataForModal.push(updatedFeedbackData);
    return updatedDataForModal;
  };

  const renderColumn = (
    item: any,
    value: any,
    columnValue: any,
    columnLabel: any,
    index: any
  ) => {
    switch (columnValue) {
      case "startDate":
        return (
          <td>
            <div className="d-flex">
              {renderingTime(item.startDate)}
              {"-"}
              {renderingTime(item.endDate)}{" "}
            </div>
          </td>
        );
      case "testDate":
        return <td>{renderingTime(item?.resultDate)}</td>;
      case "format":
        return (
          <td>
            {item?.testType} |{item?.mode}
          </td>
        );
      case "followUpCount":
        return (
          <td
            onClick={() =>
              togglePopover(
                "followUpCount" + index,
                returnFollowUpCount(item.followUpCount, item.ptmCount)
              )
            }
            className="hovertableRowcell"
            onMouseLeave={closePopover}
            id={"followUpCount" + index}
          >
            <Popover
              placement="bottom"
              isOpen={
                hoveredColumn == "followUpCount" + index ? popoverOpen : false
              }
              target={"followUpCount" + index}
              toggle={closePopover}
            >
              <PopoverBody className="FacultyTablePopover">
                {popoverContent?.map((ele: any, index: number) => (
                  <div
                    key={index}
                    className="markedLectureCountStyle d-flex flex-column justify-content-between mb-2"
                  >
                    <div className="d-flex flex-row w-100">
                      <Typography variant="h6" color="black">
                        {ele.label} &nbsp;
                      </Typography>
                      <Typography variant="h6" color="black">
                        {ele.value}
                      </Typography>
                    </div>
                  </div>
                ))}
              </PopoverBody>
            </Popover>
            <div
              className={
                item.followUpCount + item.ptmCount > 0 ? "filterSpan" : ""
              }
            >
              {item.followUpCount + item.ptmCount > 0
                ? item.followUpCount + item.ptmCount
                : "-"}
            </div>
          </td>
        );

      case "markedAttdCount":
        return (
          <td
            onClick={() =>
              togglePopover(
                "markedAttdCount" + index,
                returnMarkedvaluue(
                  "Attendance",
                  item.markedAttdCount,
                  item.unmarkedAttdCount
                )
              )
            }
            className="hovertableRowcell"
            onMouseLeave={closePopover}
            id={"markedAttdCount" + index}
          >
            <Popover
              placement="bottom"
              isOpen={
                hoveredColumn == "markedAttdCount" + index ? popoverOpen : false
              }
              target={"markedAttdCount" + index}
              toggle={closePopover}
            >
              <PopoverBody className="FacultyTablePopover">
                {popoverContent?.map((ele: any, index: number) => (
                  <div
                    key={index}
                    className="markedLectureCountStyle d-flex flex-column justify-content-between mb-2"
                  >
                    <div className="d-flex flex-row w-100">
                      <Typography variant="h6" color="black">
                        {ele.label} &nbsp;
                      </Typography>
                      <Typography variant="h6" color="black">
                        {ele.value}
                      </Typography>
                    </div>
                  </div>
                ))}
              </PopoverBody>
            </Popover>
            <div
              className={
                returnPercentage(item.markedAttdCount, item.unmarkedAttdCount)
                  ? "filterSpan"
                  : ""
              }
            >
              {returnPercentage(item.markedAttdCount, item.unmarkedAttdCount)
                ? returnPercentage(
                    item.markedAttdCount,
                    item.unmarkedAttdCount
                  ) + "%"
                : "-"}
            </div>
          </td>
        );

      case "name":
        return (
          <td>
            <span
              className="filterSpan"
              onClick={() => routeToPerformance(item)}
            >
              {value && capitalizeWords(value)} | {item?.employeeId}
            </span>
          </td>
        ); //
      case "branch":
        return (
          <td
            onClick={() => togglePopover("branch" + index, item.branch)}
            onMouseLeave={closePopover}
            id={"branch" + index}
          >
            <Popover
              placement="bottom"
              isOpen={hoveredColumn == "branch" + index ? popoverOpen : false}
              target={"branch" + index}
              toggle={closePopover}
            >
              <PopoverBody className="FacultyTablePopover">
                {popoverContent?.map((ele: any, index: number) => (
                  <div
                    key={index}
                    className="branchListing d-flex justify-content-between mb-2"
                  >
                    {ele}
                  </div>
                ))}
              </PopoverBody>
            </Popover>
            <div className="d-flex gap-2">
              {item.branch && item.branch.length > 1 ? (
                <>
                  {item.branch[0]}{" "}
                  <span className="filterSpan d-flex align-items-center">
                    +{item.branch?.length - 1}
                  </span>
                </>
              ) : (
                <>{item.branch}</>
              )}
            </div>
          </td>
        );
      case "subjects":
        return (
          <td
            onClick={() => togglePopover("subject" + index, item.subjects)}
            onMouseLeave={closePopover}
            id={"subject" + index}
          >
            <Popover
              placement="bottom"
              isOpen={hoveredColumn == "subject" + index ? popoverOpen : false}
              target={"subject" + index}
              toggle={closePopover}
            >
              <PopoverBody className="FacultyTablePopover">
                {popoverContent?.map((ele: any, index: number) => (
                  <div
                    key={index}
                    className="branchListing d-flex justify-content-between mb-2"
                  >
                    {ele}
                  </div>
                ))}
              </PopoverBody>
            </Popover>
            <div className="d-flex gap-2">
              {item.subjects && item.subjects.length > 1 ? (
                <>
                  {item?.subjects?.[0]}{" "}
                  <span className="filterSpan d-flex align-items-center">
                    +{item?.subjects?.length - 1}
                  </span>
                </>
              ) : (
                <>{item?.subjects?.[0]}</>
              )}
            </div>
          </td>
        );
      case "markedLectureCount":
        return (
          <td
            onClick={() =>
              togglePopover(
                "markedLectureCount" + index,
                returnMarkedvaluue(
                  "Lectures",
                  item.markedLectureCount,
                  item.unmarkedLectureCount
                )
              )
            }
            className="hovertableRowcell"
            onMouseLeave={closePopover}
            id={"markedLectureCount" + index}
          >
            <Popover
              placement="bottom"
              isOpen={
                hoveredColumn == "markedLectureCount" + index
                  ? popoverOpen
                  : false
              }
              target={"markedLectureCount" + index}
              toggle={closePopover}
            >
              <PopoverBody className="FacultyTablePopover">
                {popoverContent?.map((ele: any, index: number) => (
                  <div
                    key={index}
                    className="markedLectureCountStyle d-flex flex-column justify-content-between mb-2"
                  >
                    <div className="d-flex flex-row w-100">
                      <Typography variant="h6" color="black">
                        {ele.label} &nbsp;
                      </Typography>
                      <Typography variant="h6" color="black">
                        {ele.value}
                      </Typography>
                    </div>
                  </div>
                ))}
              </PopoverBody>
            </Popover>
            <div className={"filterSpan"}>
              {" "}
              {returnPercentage(
                item.markedLectureCount,
                item.unmarkedLectureCount
              )}
              %
            </div>
          </td>
        );
      case "overallRatingAvg":
        return (
          <td onClick={() => handleOverAllratingmodal(item)}>
            {item.overallRatingAvg === 0 ? "-" : item.overallRatingAvg}
          </td>
        );
      default:
        return <td>{value ? value : "-"}</td>;
    }
  };
  const handleSort = (column: any) => {
    sortOrder === SORT_ASC ? setSortOrder(SORT_DESC) : setSortOrder(SORT_ASC);
    setSortColumn(column);
  };
  return (
    <div
      className={
        !["xs", "sm", "md"].includes(screen)
          ? "facultyDiv pr-3"
          : "facultyDivMB"
      }
    >
      <Card className="mb-0 table-border-custom">
        <div className="tableFixHead">
          {!tableloading && tableData && tableData.length === 0 ? (
            <div className="mt-4 mb-8">
              <NoResultFoundSearch
                primaryMessage="Faculties list not available"
                secondaryMessage={
                  "No faculties allocated to the assigned Branch and Stream. Contact your EDP team for assistance."
                }
              >
                <NoDataFoundIcon />
              </NoResultFoundSearch>
            </div>
          ) : (
            <Table responsive className="table table-hover table-border-custom">
              <thead className="table-light-custom border-top table-border-custom">
                {tableHeading.map(
                  (column: { label: string; value: string }, index: number) => {
                    return (
                      <th
                        key={index}
                        onClick={() => {
                          if (sortingArray.includes(column.value)) {
                            handleSort(column.value);
                          }
                        }}
                      >
                        {column.label}
                        {sortingArray.includes(column.value) ? (
                          <span className="cursor-pointer">
                            {sortColumn == column.value &&
                            sortOrder === SORT_ASC ? (
                              <img width={16} height={12} src={UpArrow} />
                            ) : (
                              <img width={16} height={12} src={DownArrow} />
                            )}
                          </span>
                        ) : null}
                      </th>
                    );
                  }
                )}
              </thead>
              <tbody>
                {tableloading ? (
                  <tr>
                    <td colSpan={6}>
                      <div className="d-flex justify-content-center">
                        <Spinner color="info" />
                      </div>
                    </td>
                  </tr>
                ) : (
                  !tableloading &&
                  tableData &&
                  Array.isArray(tableData) &&
                  tableData.map((TestsItem: any, index: any) => {
                    return (
                      <tr key={index}>
                        {tableHeading.map(
                          (column: { label: string; value: string }) => (
                            <>
                              {" "}
                              {renderColumn(
                                TestsItem,
                                TestsItem[column.value],
                                column.value,
                                column.label,
                                index
                              )}
                            </>
                          )
                        )}
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>
          )}
        </div>
      </Card>
      {isLectureViewModal && selectedRowItem && (
        <FeedbackViewModal
          setYearMonthForFeedback={null}
          mode="myBatchLectureABC"
          selectedlecture={null}
          isLectureViewModal={isLectureViewModal}
          setIsLectureViewModal={setIsLectureViewModal}
          facultyFeedbackData={mapData(selectedRowItem, [])}
        ></FeedbackViewModal>
      )}
    </div>
  );
};

export default FacultiesTable;
